/* eslint-disable */
import Vue from 'vue'
import axios from 'axios'
import { Message } from 'element-ui'
import router from "@/router";

axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? '/api' : '/api'
axios.defaults.validateStatus = status => {
  return status >= 200 && status < 250
}
axios.defaults.timeout = 600000;
axios.interceptors.request.use(item => {
  item.headers.token = localStorage.getItem('token')
  if (!item.headers.tenantId) {
    item.headers.tenantId = 906
  }
  return item
}, error => {
  Message.error('请检查网络连接！')
  return Promise.reject(error)
})

axios.interceptors.response.use(item => { //拦截响应
  if (item.request.responseType === 'arraybuffer') {
    const disposition = item.headers['content-disposition']
    sessionStorage.fileName = decodeURI(disposition.slice(disposition.indexOf('filename=') + 9))
    return item
  } else {
    if (item.data.code === '0000' || item.data.code === '200') {
      return item
    } else if (item.data.code === '2010') {
      if (item.data.message)
        Message.error(item.data.message)
      else if (item.data.msg)
        Message.error(item.data.msg)
      else
        Message.error('网络错误！')
      router.replace({ name: "login" })
      localStorage.removeItem('token')
      return Promise.reject(error)
    } else {
      if (item.data.message)
        Message.error(item.data.message)
      else if (item.data.msg)
        Message.error(item.data.msg)
      else
        Message.error('网络错误！')
      return Promise.reject(error)
    }
  }
}, error => {
  const status = error.response.status
  switch (status) {
    case 403:
      break
    default:
      break
  }
  const msg = error.response.data.msg ? error.response.data.msg : error.response.data.message ? error.response.data.message : '网络错误！';
  Message.error(msg);
  return Promise.reject(error)
})

Vue.prototype.$axios = axios

export default axios
